export default __webpack_public_path__ + "static/media/slack.543f8b1a.jpg";